<template>
  <div class="store_list nodrag">
    <div class="base">
      <div class="list_thumb">
        <div class="n_thumb">
          <vue-skeleton-loader type="rect" :color="color" />
        </div>
      </div>
      <div class="store_info">
        <div class="ttl">
          <h1>
            <vue-skeleton-loader :color="color" :height="27" :width="100" />
          </h1>
          <p>
            <vue-skeleton-loader :color="color" :height="15" />
          </p>
        </div>
        <div class="shop_index_wrap">
          <div class="shop_index">
            <dl>
              <vue-skeleton-loader :color="color" :height="15" :width="120" />
            </dl>
          </div>
          <div class="shop_index">
            <dl>
              <vue-skeleton-loader :color="color" :height="15" :width="180" />
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'skeleton-store-item',
  descriptoin: '스켈레톤 동네매장 정보',
  data() {
    return {
      color: 'rgba(0, 0, 0, 0.07)',
    };
  },
};
</script>

<style scoped></style>
